import React, { FC } from 'react'
import styles from './Reply.module.scss'
import LogoIcon from '../../../public/static/icons/logo-currentColor.svg'

const Reply: FC<{ text: string }> = ({ text }) => {
  return (
    <>
      <div className={styles.top}>
        <div className={styles.avatar}>
          <LogoIcon />
        </div>
        <p className={styles.name}>Kristall Minerals cosmetics</p>
      </div>
      <p className={styles.text}>{text}</p>
    </>
  )
}

export default Reply
